import React, { lazy, useEffect, useState, Suspense, useContext } from "react";
import { Route, Switch } from "react-router-dom";

import ModulePage from "../../containers/ModulePage";
// const ModulePage = lazy(() => import("../../containers/ModulePage"));
import SearchPage from "../../containers/SearchPage";
// const SearchPage = lazy(() => import("../../containers/SearchPage"));
import AdDetailsPage from "../../containers/AdDetailsPage";
// const AdDetailsPage = lazy(() => import("../../containers/AdDetailsPage"));
import AdFormPage from "../../containers/AdFormPage";
// const AdFormPage = lazy(() => import("../../containers/AdFormPage"));
import { InvalidPage } from "../../components/InvalidPage";
import { CurrentPage, ModuleNameHr, PageRoute, QueryParam } from "../../models/enums";
import SubLevel1 from "../../containers/ModulePage/SubLevel1";
// const SubLevel1 = lazy(() => import("../../containers/ModulePage/SubLevel1"));
import SubLevel2 from "../../containers/ModulePage/SubLevel2";
// const SubLevel2 = lazy(() => import("../../containers/ModulePage/SubLevel2"));
import SelectingCategory from "../../containers/AdFormPage/SelectingCategory";
import RealEstatePricesSelection from "../../containers/RealEstatePricesPage/Selection";
import RealEstatePricesResults from "../../containers/RealEstatePricesPage/Results";
import MakeModelInfoPage from "../../containers/MakeModelInfoPage";
// const SelectingCategory = lazy(() =>
//   import("../../containers/AdFormPage/SelectingCategory")
// );

import history from "../../history";
import { Loading } from "../../components/Loading";
import { getUrlParams } from "../../services";
import { routeInterface } from "../../typings/interfaces";
import { Context } from "../../GAContext";

const General = (props: any) => {
  const {
    match: { path },
    showHeaderLogoAndSearchBar,
    location: { pathname, search },
    routes,
  } = props;

  const [metaData, setMetaData] = useState(null);
  const [queryParams, setQueryParams] = useState(null);
  const [, setGaEvent] = useContext(Context);


  useEffect(() => {
    setGaEvent(CurrentPage.module);
    return () => {
      setGaEvent("");
    };
  }, []);

  useEffect(() => {
    const route = routes.find(route => route.to == pathname);

    if (route && route.searchQuery) {
      if (route.to == pathname && !getUrlParams(search, QueryParam.searchQuery)) {
        history.replace(`${route.to}${(route.searchQuery ? "?" + QueryParam.searchQuery + "=" + route.searchQuery : "")}`);
      }
    }

    if (route) {
      setMetaData({
        title: route.MetaTitle,
        description: route.MetaDescription,
        h1: route.H1
      });
    } else if (metaData != null) {
      setMetaData(null);
    }

    if (route && route.searchQuery) {
      setQueryParams(route.searchQuery);
    } else if (queryParams != null) {
      setQueryParams(null);
    }
  }, [pathname, routes, search]);

  const resolveComponents = component => {
    switch (component) {
      case 1:
        return <ModulePage {...props} metaData={metaData} />;
      case 2:
        return (
          <SubLevel1
            {...props}
            metaData={metaData}
            showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBar}
          />
        );
      case 3:
        return (
          <SearchPage
            {...props}
            metaData={metaData}
            showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBar}
          />
        );
      case 4:
        return <SubLevel2 metaData={metaData} />;
    }
  };

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route
          path={path}
          exact
          component={() => <ModulePage {...props} metaData={metaData} />}
        />

        <Route
          path={`${path}${PageRoute.postAd}`}
          component={SelectingCategory}
        />

        <Route
          path={`/${ModuleNameHr.realEstate}${PageRoute.realEstatePrices}`}
          exact
          component={RealEstatePricesSelection}
        />

        <Route
          path={`/${ModuleNameHr.realEstate}${PageRoute.realEstatePrices}/:type/:county/:city/:settlement`}
          exact
          component={RealEstatePricesResults}
        />

        <Route
          path={`/${ModuleNameHr.realEstate}${PageRoute.realEstatePrices}/:type/:county/:city`}
          exact
          component={RealEstatePricesResults}
        />

        <Route
          path={`/${ModuleNameHr.realEstate}${PageRoute.realEstatePrices}/:type/:county`}
          exact
          component={RealEstatePricesResults}
        />

        <Route
          path={`/${ModuleNameHr.realEstate}/:category`}
          exact
          component={props => (
            <ModulePage
              {...props}
              metaData={metaData}
              showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBar}
            />
          )}
        />

        <Route
          path={`${path}`}
          exact
          component={props => (
            <SubLevel1
              {...props}
              metaData={metaData}
              showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBar}
            />
          )}
        />

        <Route
          path={`${path}${PageRoute.search}`}
          exact
          render={props => (
            <SearchPage
              {...props}
              metaData={metaData}
              showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBar}
            />
          )}
        />

        <Route
          path={`${path}/:type/:category/:location${PageRoute.search}`}
          exact
          render={props => (
            <SearchPage
              {...props}
              metaData={metaData}
              showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBar}
            />
          )}
        />

        {/* subcategory + make + model of a vehicle category (gospodarska-vozila/kombi-i-dostavna-vozila/citroen/berlingo) */}
        <Route
          path={`${path}/:type/:category/:location/:model${PageRoute.search}`}
          exact
          render={props => (
            <SearchPage
              {...props}
              metaData={metaData}
              showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBar}
            />
          )}
        />

        <Route
          path={`${path}/:category${PageRoute.search}`}
          exact
          render={props => (
            <SearchPage
              {...props}
              metaData={metaData}
              showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBar}
            />
          )}
        />

        <Route
          path={`${path}/:type/:category${PageRoute.search}`}
          exact
          render={props => (
            <SearchPage
              {...props}
              metaData={metaData}
              showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBar}
            />
          )}
        />

        <Route
          path={`${path}/:category/:makeSlug/:modelSlug/:yearRange/info`}
          exact
          render={props => (
            <MakeModelInfoPage {...props} metaData={metaData} />
          )}
        />

        <Route
          path={`${path}/:category/:makeSlug/:modelSlug/info`}
          exact
          render={props => (
            <MakeModelInfoPage {...props} metaData={metaData} />
          )}
        />

        <Route path={`${path}${PageRoute.editAd}/:id`} component={AdFormPage} />

        <Route
          path={`${path}/:category${PageRoute.details}/*/:id`}
          component={AdDetailsPage}
          exact
        />


        <Route
          path={`${path}/:category`}
          exact
          render={props => (
            <SubLevel1
              {...props}
              metaData={metaData}
              // @ts-ignore
              showHeaderLogoAndSearchBar={showHeaderLogoAndSearchBar}
            />
          )}
        />

        <Route path={`${path}/:category/:level1`} component={SubLevel2} />

        <Route component={InvalidPage} />
        {routes && routes.map((route: routeInterface, i: number) => {
          return (
            route.to && (
              <Route
                path={`${route.to}${(route.searchQuery ? "?" + QueryParam.searchQuery + "=" + route.searchQuery : "")}`}
                exact
                component={() => resolveComponents(route.Component)}
                key={i}
              />
            )
          );
        })}
      </Switch>
    </Suspense>
  );
};

export default General;



// WEBPACK FOOTER //
// ./src/routes/General/General.tsx